import React from 'react'
import ICSButton from '../../../../components/ICS/Button/ICSButton'
import { downloadResultFile, getResultFile } from '../../../../redux/slices'
import { AppDispatch } from '../../../../services/lib'
import { useDispatch } from 'react-redux'
import { ResultFileDownloadResponse } from '../../../../types'

export const onDownloadClick = async (
  e,
  dispatch: AppDispatch,
  fileName: string
) => {
  const resultFileRes = await dispatch(
    getResultFile({
      resultFileId: e.element.attributes.id.nodeValue,
      query: {},
    })
  )

  if (resultFileRes.type.split('/').pop() === 'fulfilled') {
    await dispatch(
      downloadResultFile({
        data: (resultFileRes.payload as ResultFileDownloadResponse).file,
        fileName,
      })
    )
  }
}

const RenderActions = ({ e }) => {
  const dispatch: AppDispatch = useDispatch()
  let dataspy = false
  const validExtensions = ['dsr', 'mf4']
  const fileName = e.row.key.name
  const extension = fileName.split('.').pop()

  if (validExtensions.includes(extension)) dataspy = true

  return (
    <div style={{display:'flex',gap:'2px'}}>
    <ICSButton
      id={e.data.resultFileId}
      key={e.data.resultFileId}
      icon='download'
      type='default'
      stylingMode='contained'
      onClick={async e => await onDownloadClick(e, dispatch, fileName)}
    />
    {dataspy &&
      <ICSButton
        id={`${e.data.resultFileId}-dataspy`}
        key={`${e.data.resultFileId}-dataspy`}
        icon='glyphicons glyphicons-stats'
        type='default'
        stylingMode='contained'
        onClick={() => window.open(e.row.key.dataSpy, '_blank')}
      />
    }
  </div>
  )
}

export default RenderActions
